<template>
  <div id="app">
    <!-- Lien d'évitement pour l'accessibilité - doit être le premier élément tabulable -->
    <a href="#main-content" class="skip-link" v-if="connected">
      {{ $t('Webheader.skip_to_main_content') }}
    </a>


    <left-panel
      v-if="connected"
      :context="context" />
    <right-panel
      v-if="connected" />
    <f7-views>
      <f7-view
        id="main-view"
        role="main"
        :domCache="false"
        :uniqueHistory="false"
        main
        :url="url"
      >
        <web-header
          v-if="connected && !isSmartphoneOS"
          :key="'web-header-' + webheaderKey"
          :context="context" />
        <mobile-header
          v-if="connected"
          :context="context" />
        <f7-pages id="main-content" :class="connected ? 'marginHomepageLargeScreen': ''"/>
      </f7-view>
    </f7-views>
    <cm-popups />
    <!-- <notifications-rtp
      style="top:80px;z-index:10070;"
    /> -->

    <user-guide />
  </div>
</template>

<script>
import WebHeader from '@/components/menus/WebHeader.vue'
import MobileHeader from '@/components/menus/MobileHeader.vue'
import LeftPanel from '@/components/menus/MobileLeftPanel.vue'
import RightPanel from '@/components/common/RightPanel.vue'
// import notificationsRTP from '@/components/common/notificationsLink.vue'

import design from '@/design/design.json'

import networkMixin from './mixins/networkMixin'

import CMPopup from '@/popups/Popups.vue'
import userGuidePopovers from '@/components/common/userGuidePopovers.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage} from '@/helpers/routing'

/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  name: 'MoneyRoad',
  components: {
    'cm-popups': CMPopup,
    'left-panel': LeftPanel,
    'mobile-header': MobileHeader,
    // 'notifications-rtp': notificationsRTP,
    'right-panel': RightPanel,
    'user-guide': userGuidePopovers,
    'web-header': WebHeader
  },
  mixins: [networkMixin], //  dynamicStyleMixin],
  data: () => {
    return {
      apiVersion: '',
      context: 'RTP',
      design: design,
      service: '',
      connected: false,
      homepageSelected: false,
      webheaderKey: false,
      defaultService: 'Direct Debit',
      surveyConnectedMins: 0,
      surveyConnectedSecs: 10,
      surveyRTPMins: 1,
      surveyRTPSecs: 0,
      url: ''
    }
  },
  computed: {
    cssVars () {
      return {
        // BOUTONS
        '--actionButtonSimpleGris': this.design.global.actionSimpleGris,
        '--actionButtonColorBlue': this.design.global.actionButtonColorBlue,
        '--borderButtonColorBlue': this.design.global.borderButtonColorBlue,
        '--actionButtonColorViolet': this.design.global.actionButtonColorViolet,
        '--borderButtonColorViolet': this.design.global.borderButtonColorViolet,
        '--borderRadius': this.design.global.borderRadius,
        // TEXTE
        '--actionTextColorWhite': this.design.global.actionTextColorWhite,
        '--actionTextColorBlack': this.design.global.actionTextColorBlack,
        '--actionTextColorWhiteHover': this.design.global.actionTextColorWhiteHover,
        // POLICE
        '--fontFamily': this.design.global.fontFamily,
        '--fontSize': this.design.global.fontSize,
        // Couleur des tableaux et onglets actifs
        "--actionButtonSimpleGrisBleu": this.design.global.actionButtonSimpleGrisBleu,
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    statusColor () {
      if (this.online) return ''
      return 'red'
    },
    surveyConnectedTimer () {
      return ((this.surveyConnectedMins * 60) + this.surveyConnectedSecs) * 1000
    },
    surveyRTPTimer () {
      return ((this.surveyRTPMins * 60) + this.surveyRTPSecs) * 1000
    },
    titleNavBar () {
      let style = {
        'background-color': this.servicesColors.DEFAULT
      }
      if (!this.online) style['background-color'] = '#f44336'
      return style
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
  },
  created () {
    let that = this
    setInterval(this.watchApiVersion, 1000)
    this.watchApiVersion()
    var data = this.getJsonFromUrl(window.location.href)
    if (data.loginSSO === '1' && data.login && data.OTP) {
      this.$engine.auth.loginOTP({ email: data.login, otp: data.OTP })
        .then(resp => {
          that.details = {}
          if (resp.status === 200) {
            setTimeout(function () { /* Timeout for letting time to load vue components */
              that.$engine.auth.ssoLogin = 1
              if (that.$engine.user.getIsFirstLogin() === '1' || that.$engine.user.get().isFirstLogin === '1') {
                that.$bus.$emit('popup-change-password-data')
              } else {
                window.location = window.location.href.split('?')[0]
              }
            }, 0)
          }
        })
        .catch(err => {
          throw new Error(err)
        })
    } else {
      if (data.OTP && data.email && data.ressource) {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource
      } else if (data.sendDocumentsFromApplication === '1') {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/sendDocumentsFromApplication'
      } else if (data.paymentFromApplication === '1') {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/paymentFromApplication'
      } else if (data.loading === '1') {
        this.url = '/loading/'
      } else if (this.$engine.applicationMode === 'standard') {
        this.url = '/login/'
      } else {
        this.url = ''
      }
      /** TLV - TBR 27/11/2017
       * Affichage du menu de gauche seulement quand un service est actif,
       * Quand il n'y a pas de service sélectionné (sur la page de connexion par exemple),
       * Le menu de gauche n'est pas affiché
       */
      this.$engine.services.directPayments.filter.smartphoneStorage = window.innerWidth <= 992
      this.$bus.$on('service:change', () => {
        this.service = this.$engine.user.currentService.name
        this.$bus.$emit('refresh-cache-menu')
      })
      this.$bus.$on('refresh-cache-menu', () => {
        this.service = this.$engine.user.currentService.name
      })
      let that = this
      this.$bus.$on('reset-webheader', () => {
        that.webheaderKey = !that.webheaderKey
      })
      this.$bus.$off('reload-app')
      this.$bus.$on('reload-app', () => {
        that.$engine.setService(that.getContext())
        that.context = that.$engine.getService()
        that.webheaderKey = !that.webheaderKey
        that.$bus.$emit('reload-homepage')
        loadPage(that, {
          url: '/home/' + that.context
        })
        that.$bus.$emit('reset-selected-menu')
      })
      this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.apiVersion = resp.data.version
          that.$engine.versionAPI = resp.data.version
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    let that = this
    this.hideApexTechnicalSvg()

    this._apexSvgObserver = new MutationObserver(() => {
      this.hideApexTechnicalSvg()
    })

    this._apexSvgObserver.observe(document.body, {
      childList: true
    })
    this.$bus.$on('login', function (login) {
      if (!login && !this.$engine.services.directPayments.filter.smartphoneStorage) {
        this.$engine.user.currentService.name = ''
        this.$bus.emit('service:change', '')
      } else if (login) {
        // TLV 08/02/2021 : showing web header unless we are using an iframe
        if (login !== 'iframe') {
          that.connected = true
        }
        if (this.$engine.user.currentService.id != null) {
          this.$bus.emit('service:change', that.$engine.services.getServiceIdByName(that.defaultService))
        } else {
          this.$bus.emit('service:change', that.defaultService)
          this.$engine.user.currentService.name = that.defaultService
          this.$engine.user.currentService.id = this.$engine.services.getServiceIdByName(that.defaultService)
        }
      }
      if (that.$engine.user.getIsFirstLogin() === '1' || that.$engine.user.get().isFirstLogin === '1') {
        that.$bus.$emit('popup-change-password-data')
      }
    })
    this.$bus.$on('logout', function (force) {
      this.$bus.$emit('close-all-popups')
      this.$engine.auth.logout(force).then(() => {
        that.connected = false
        this.$engine.user.currentService.name = ''
        this.$bus.$emit('service:change', '')
        reloadPage(that, {
          url: '/login/',
          force: true,
          ignoreCache: true
        })
      })
    })
    this.$bus.$on('isOnHomepage', function (currentlyOnHomepage) {
      that.homepageSelected = currentlyOnHomepage
    })

    for (let key in this.cssVars) {
      document.documentElement.style.setProperty(key, this.cssVars[key])
    }
    setInterval(this.checkAppVersion(), 30000)
    this.checkAppVersion()
    this.surveyConnected()
    // this.surveyRTP()
  },
  beforeDestroy () {
    if (this._apexSvgObserver) {
      this._apexSvgObserver.disconnect()
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  methods: {
    hideApexTechnicalSvg () {
      document
          .querySelectorAll(
              'body > svg[id^="SvgjsSvg"][width="2"][height="0"]'
          )
          .forEach(svg => {
            svg.setAttribute('aria-hidden', 'true')
            svg.setAttribute('focusable', 'false')
            svg.setAttribute('role', 'presentation')
          })
    },
    checkAppVersion () {
      let that = this
      fetch('config.xml')
      .then(res => res.text())
      .then(str => {
        const parser = new DOMParser()
        const version = parser.parseFromString(str, "application/xml")?.querySelector('widget')?.getAttribute('version')
        let localVersion = that.$engine.getIHMVersion()
        if (version) {
          if (localVersion) {
            if (version !== localVersion) {
              that.$engine.setIHMVersion(version)
              location.reload(true);
            }
          } else {
            that.$engine.setIHMVersion(version)
          }
        }
      })
    },
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    },
    surveyConnected () {
      let that = this
      setTimeout(function () {
        if (that.connected && that.$engine.common.network.isSessionExpired()) {
          that.$engine.user.manageSession()
          .then(() => {
          })
          .catch(err => {
            errorMessageAlert(err, that, true)
          })
          .finally(() => {
            that.surveyConnected()
          })
        } else {
          that.surveyConnected()
        }
      }, that.surveyConnectedTimer)
    },
    surveyRTP () {
      let that = this
      setTimeout(function () {
        if (that.connected && (that.$engine.rights.rightIs('rtp_sendbox_consulter', true) || that.$engine.rights.rightIs('rtp_backoffice_consulter', true))) {
          that.$engine.services.payments.surveyPayments()
          .then(resp => {
            if (resp.data && resp.data.nbTotal) {
              let title = that.$i18n.t('common.new_notif')
              let desc = []
              if (resp.data.nbNew) {
                desc.push(that.$i18n.t('requestToPay.x_rtp_received', {nbRTP: resp.data.nbNew}))
              }
              if (resp.data.nbCanceled) {
                desc.push(that.$i18n.t('requestToPay.x_rtp_canceled', {nbRTP: resp.data.nbCanceled}))
              }
              that.$bus.emit('rtp-notif', {
                title: title,
                description: desc
              })
            }
          })
          .catch(err => {
            errorMessageAlert(err, that, true)
          })
          .finally(() => {
            that.surveyRTP()
          })
        } else {
          that.surveyRTP()
        }
      }, that.surveyRTPTimer)
    },
    watchApiVersion () {
      let newApiVersion = this.$engine.common.network.getAPIVersion()
      if (!this.apiVersion) {
        this.apiVersion = newApiVersion
      } else if (this.apiVersion !== newApiVersion) {
        window.location.reload(true)
      }
    }
  }
}
</script>

<style media="screen">
.hiddenBlock {
  display: none;
}

@media (min-width: 850px) {
  .marginHomepageLargeScreen {
    top: 80px; max-height: calc(100% - 80px);
  }
}

</style>
